import {Provider} from 'react-redux';
import * as Sentry from '@sentry/react';
import {TranslationProvider} from './translationService';
import Router from './Router';
import store from './store';

const App = () => {
    const onBeforeCapture = scope => {
        scope.setLevel('fatal');
    };

    return (
        <Sentry.ErrorBoundary beforeCapture={onBeforeCapture}>
            <TranslationProvider>
                <Provider store={store}>
                    <Router/>
                </Provider>
            </TranslationProvider>
        </Sentry.ErrorBoundary>
    );
};

export default App;
